<template>
  <div class="shareAndEarn">
    <div class="share" @click="shareFunc(details.shareMessageUrl,details.itemMediaDTOList[0].original, details.saleReferenceID)">
      <div class="share_link">
        <h3 class="share_hdng">{{$t('shareAndEarnInNetwork')}}</h3>
        <p class="cashback_txt">{{$t('getCash')}}</p>
        <div class="customButtom">
          <button type="button" class="share_btn" >{{$t('shareAndEarn')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "../../../main";
export default {
  name: "ShareAndEarn",
  props: {
    dataShareAndEarn: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      shareLinkData: {},
      details: {},
      loading: false
    };
  },
  watch: {
    dataShareAndEarn() {
      this.details = this.dataShareAndEarn;
    }
  },
  methods: {
    shareFunc(shareMessage, shareImage, saleReferenceID) {
      clevertap.event.push("Share_Product_Via_Detail_Page")
      this.loading = true;
      this.$store
        .dispatch({ type: "getShareDetailsByItem", payload: saleReferenceID })
        .then(data => {
          this.shareLinkData = data.data;
          this.loading = false;
          shareMessage = data.data.shareMessage;
          const obj = {
            message: shareMessage,
            imageUrl: shareImage
          };
          try {
            JSBridgePlugin.share(JSON.stringify(obj));
          } catch (err) {
            console.log(err);
            window.open("whatsapp://send?text=" + shareMessage);
          }
        })
        .catch(err => {
          this.loading = false;
          let obj = {
            status: "Failure",
            timeoutMs: "5000"
          };
          bus.$emit("apiStatus", obj);
        });
    }
  },
  mounted() {
    this.details = this.dataShareAndEarn;
  }
};
</script>
    